<template>
  <div>
    <!-- Оверлей со спиннером -->
    <div v-if="isLoading" class="overlay">
      <div class="spinner"></div>
    </div>
    <div class="cont">
      <div class="row" style="min-height: inherit">
        <header class="header bg-light"></header>
        <main class="main bg-light">
          <div class="row">
            <div class="col-12">
              <!-- Login 13 - Bootstrap Brain Component -->

              <section class="py-3 py-md-5">
                <div class="container">
                  <div class="row justify-content-center">
                    <div
                      class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4"
                    >
                      <div
                        class="card border border-light-subtle rounded-3 shadow-sm"
                      >
                        <div class="card-body p-3 p-md-4 p-xl-5">
                          <div class="text-center mb-3">
                            <a href="#!">
                              <img
                                src="@/assets/LOGO LIP.svg"
                                alt="LOGO"
                                width="80"
                                height="80"
                              />
                            </a>
                          </div>
                          <h2
                            class="fs-6 fw-normal text-center text-secondary mb-4"
                          >
                            Вход в личный кабинет
                          </h2>

                          <div class="row gy-2 overflow-hidden">
                            <div class="col-12">
                              <div class="form-floating mb-3">
                                <FloatLabel variant="on">
                                  <InputMask
                                    id="uid"
                                    class="w-100 text-center"
                                    size="large"
                                    v-model="uid"
                                    mask="999-999"
                                  />
                                  <label for="uid">Введите UID</label>
                                </FloatLabel>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-floating mb-3">
                                <FloatLabel variant="on">
                                  <IconField>
                                    <InputMask
                                      id="birthdate"
                                      class="w-100 text-center"
                                      size="large"
                                      v-model="birthdate"
                                      mask="99.99.9999"
                                      autocomplete="off"
                                    />
                                    <InputIcon class="pi pi-calendar" />
                                  </IconField>
                                  <label for="birthdate"
                                    >Дата рождения [дд.мм.гггг]</label
                                  >
                                </FloatLabel>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="d-flex gap-2 justify-content-between">
                                <div class="">
                                  <Checkbox
                                    v-model="pizza"
                                    inputId="ingredient1"
                                    name="pizza"
                                    value="Cheese"
                                    class="me-2 ml-0 pl-0"
                                  />
                                  <label
                                    class="form-check-label text-secondary"
                                    for="ingredient1"
                                  >
                                    Запомнить
                                  </label>
                                </div>

                                <Button
                                  label="Напомнить UID?"
                                  variant="link"
                                  severity="success"
                                  class="py-0"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!-- Добавляем компонент Message для отображения ошибок -->
              <div class="col-12" v-if="errorMessage">
                <Message severity="error" class="mt-3 mx-3">{{
                  errorMessage
                }}</Message>
              </div>
            </div>
          </div>
        </main>

        <footer class="footer bg-light pb-3">
          <div class="row">
            <div class="col-12">
              <!-- Login 13 - Bootstrap Brain Component -->
              <section class="py-3 py-md-5">
                <div class="container">
                  <div class="row justify-content-center">
                    <div
                      class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4"
                    >
                      <div class="card border-0 bg-transparent">
                        <Button
                          label="Войти"
                          style="background-color: #4caf50"
                          rounded
                          raised
                          @click="handleSignIn"
                        />

                        <div class="col-12">
                          <div class="d-grid my-2 px-2">
                            <Button
                              label="Регистрация"
                              severity="info"
                              @click="navigateToRegister"
                              variant="text"
                            />
                          </div>
                        </div>
                        <!--  Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Lorem ipsum, dolor sit amet
                        consectetur adipisicing elit. Lorem ipsum, dolor sit
                        amet consectetur adipisicing elit. Lorem ipsum, dolor
                        sit amet consectetur adipisicing elit. Lorem ipsum,
                        dolor sit amet consectetur adipisicing elit. Lorem
                        ipsum, dolor sit amet consectetur adipisicing elit.
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Lorem ipsum, dolor sit amet
                        consectetur adipisicing elit. Lorem ipsum, dolor sit
                        amet consectetur adipisicing elit. Lorem ipsum, dolor
                        sit amet consectetur adipisicing elit. Lorem ipsum,
                        dolor sit amet consectetur adipisicing elit. Lorem
                        ipsum, dolor sit amet consectetur adipisicing elit.
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Lorem ipsum, dolor sit amet
                        consectetur adipisicing elit. Lorem ipsum, dolor sit
                        amet consectetur adipisicing elit. Lorem ipsum, dolor
                        sit amet consectetur adipisicing elit. Lorem ipsum,
                        dolor sit amet consectetur adipisicing elit. Lorem
                        ipsum, dolor sit amet consectetur adipisicing elit.
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Lorem ipsum, dolor sit amet
                        consectetur adipisicing elit. Lorem ipsum, dolor sit
                        amet consectetur adipisicing elit. Lorem ipsum, dolor
                        sit amet consectetur adipisicing elit. Lorem ipsum,
                        dolor sit amet consectetur adipisicing elit. Lorem
                        ipsum, dolor sit amet consectetur adipisicing elit.
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Lorem ipsum, dolor sit amet
                        consectetur adipisicing elit. Lorem ipsum, dolor sit
                        amet consectetur adipisicing elit. Lorem ipsum, dolor
                        sit amet consectetur adipisicing elit. Lorem ipsum,
                        dolor sit amet consectetur adipisicing elit. Lorem
                        ipsum, dolor sit amet consectetur adipisicing elit.
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Lorem ipsum, dolor sit amet
                        consectetur adipisicing elit. Lorem ipsum, dolor sit
                        amet consectetur adipisicing elit. Lorem ipsum, dolor
                        sit amet consectetur adipisicing elit. Lorem ipsum,
                        dolor sit amet consectetur adipisicing elit. Lorem
                        ipsum, dolor sit amet consectetur adipisicing elit.
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. -->
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent } from "vue";
import { useRouter } from "vue-router";
import { signIn } from "@/services/api";

export default defineComponent({
  name: "SignIn",
  setup() {
    const uid = ref(""); // UID пользователя
    const birthdate = ref(""); // Дата рождения
    const pizza = ref(false); // Состояние чекбокса "Запомнить"
    const errorMessage = ref(""); // Сообщение об ошибке
    const successMessage = ref(""); // Сообщение об успешной авторизации
    const isLoading = ref(false); // Состояние загрузки
    const router = useRouter();

    const handleSignIn = async () => {
      isLoading.value = true; // Показываем спиннер
      try {
        // Отправляем запрос на авторизацию
        const result = await signIn(uid.value, birthdate.value);

        // Если успешно, сохраняем сообщение
        successMessage.value = result.message;

        // Перенаправляем на главную страницу или другую логику
        setTimeout(() => {
          isLoading.value = false; // Скрываем спиннер перед редиректом
          router.push("/home");
        }, 2000); // Пример задержки перед редиректом
      } catch (error: any) {
        console.log(error);
        // Получаем текст ошибки и убираем префикс "Error:"
        const errorText = error.message || String(error);
        errorMessage.value = errorText.replace(/^Error:\s*/, "");
        isLoading.value = false; // Скрываем спиннер при ошибке
      }
    };

    const navigateToRegister = () => {
      router.push("/register"); // Переход на страницу регистрации
    };

    const navigateToHome = () => {
      router.push("/home"); // Переход на страницу регистрации
    };

    return {
      navigateToRegister,
      navigateToHome,
      uid,
      birthdate,
      pizza,
      errorMessage,
      handleSignIn,
      successMessage,
      isLoading,
    };
  },
});
</script>

<style lang="scss">
main.main {
  display: flex;
  justify-content: center; /* Горизонтальное центрирование */
  align-items: center; /* Вертикальное центрирование */
  /* min-height: 100vh; /* Устанавливает минимальную высоту равной высоте экрана */
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.cont {
  min-height: 100vh;
  display: flex;
  background-color: var(--bg-gray);
  flex-direction: column;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spinner {
  border: 8px solid rgba(255, 255, 255, 0.3);
  border-top: 8px solid #fff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
